import { render, staticRenderFns } from "./VideoArchivedPlayer.vue?vue&type=template&id=41718e60&scoped=true&"
import script from "./VideoArchivedPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoArchivedPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoArchivedPlayer.vue?vue&type=style&index=0&id=41718e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41718e60",
  null
  
)

export default component.exports